import { render } from "./UsageTips.vue?vue&type=template&id=5f02f0cd"
import script from "./UsageTips.vue?vue&type=script&lang=js"
export * from "./UsageTips.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__